import type { ContentReference } from '../../../../customTypings/epiBaseModels';
import getLocalApiAxiosClient from '../clients/localApiAxiosClient';

const getDistributionAd = async (recipeExternalId: string) => {
    const response = await getLocalApiAxiosClient().get<ContentReference>(
        `/recipe/distributionad/${recipeExternalId}`,
    );
    return response.data;
};

export default {
    getDistributionAd,
};
